//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Preferences.js";
import "../no/Object.js";
import "../Preferences/Preferences.PartPreferences.js";
let d=[[[0,"CurveTolerance",1,0],[0,"DashSize",1,0],[0,"LineFontDisplay",1,0],[0,"ShowWidths",1,0],[0,"SpaceSize",1,0],[0,"SymbolSize",1,0],[0,"WidthScale",1,0]],[[["show_widths","width_scale"],"GetWidthOptions",{},0,0],[["show_widths","width_scale"],"SetWidthOptions",{},2,0],[["numPixelWidths","pixelWidths"],"GetPixelWidths",{},0,0],[["pixelWidths"],"SetPixelWidths",{},1,0],[["useWidthScale","widthScale","numPixelWidths","pixelWidths"],"GetPixelWidthOptions",{},0,0],[["useWidthScale","widthScale","pixelWidths"],"SetPixelWidthOptions",{},3,0],[[],"ResetPixelWidthOptions",{},0,0],[["updateModeChanged","studio"],"RegenerateFromToleranceChange",{},2,0],[["softwareUpdate"],"UpdateLineFontObjects",{},1,0]],[]];
SPLM.Preferences.PartVisualizationLine = class extends SPLM.Object{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Preferences.PartVisualizationLine";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Preferences.PartVisualizationLine.LineFontDisplayType = Object.freeze({
    "Software" : "Software", "Hardware" : "Hardware"});

export default SPLM;